export const DASHLET_CONFIG = {
  name: (t) => t('Dashlet'),
  blockType: 'dashlet',
  messages: {
    success: (t) => t('Dashlet config generated successfully'),
    failure: (t) => t('Dashlet config generation failed, please try again later'),
    placeholderEdit: (t) => t('Update your dashlet using AI'),
    placeholderCreate: (t) => t('Create a dashlet using AI'),
    building: (t) => t('Building your dashlet'),
    successMessage: (t) => t('Dashlet Generated Successfully'),
    failureMessage: (t) => t('Dashlet Generation Failed, Please try again later'),
    initialEdit: (t) => t('How would you like to update your dashlet?'),
    initialCreate: (t) => t('What type of dashlet would you like to create?'),
  },
};

export const CHART_CONFIG = {
  name: (t) => t('Chart'),
  blockType: 'chart',
  messages: {
    success: (t) => t('Chart config generated successfully'),
    failure: (t) => t('Chart config generation failed, please try again later'),
    placeholderEdit: (t) => t('Update your chart using AI'),
    placeholderCreate: (t) => t('Create a chart using AI'),
    building: (t) => t('Building your chart'),
    successMessage: (t) => t('Chart Generated Successfully'),
    failureMessage: (t) => t('Chart Generation Failed, Please try again later'),
    initialEdit: (t) => t('How would you like to update your chart?'),
    initialCreate: (t) => t('What type of chart would you like to create?'),
  },
};
